/* -------------------------------------------------------------------------------------
Vuex helper module to communicate if user is loggedIn

Main components
---------------
mutations:
- 

actions:
- 
---------------------------------------------------------------------------------------*/

import { mapGetters } from 'vuex'

// returns if user is logged in
export const authComputed = {
  ...mapGetters({ loggedIn: 'user/loggedIn' })
}